<p-breadcrumb [model]="breadCrumbItems"></p-breadcrumb>

<br>

<div class="p-grid">
  <div class="p-col-12 p-sm-12 p-md-11 p-xl-9">
    <div class="card card-w-title">
      <!--  DataView  -->
      <p-dataView [value]="tipos" layout="grid" [loading]="loading" emptyMessage="Sin resultados" [paginator]="false">
        <!--   DataView items   -->
        <ng-template let-tipo pTemplate="gridItem">
            <div class="item-div p-col-12 p-sm-6 p-md-12 p-lg-12">
              <div class="menu--items-ne">
                <div class="icon-menu--service">
                  <img [src]="tipo.imagen" [alt]="tipo.nombre" class="img-icon-list">
                </div>
                <div class="content-menu--service">
                  <p class="title-menu--service">{{ tipo.nombre }}</p>
                  <p class="description-menu--service"> {{tipo.descripcion || 'Descripción no disponible'}}</p>
                  <a class="color-blue menu-link--service" [routerLink]="[tipo.codigo]">Continuar con este trámite</a>
                </div>
              </div>
            </div>
        </ng-template>
      </p-dataView>
    </div>
  </div>
  <div class="p-col-4 p-md-4 p-sm-12">
    <div class="p-card--noshadow padding-min">
      <div class="container-center">
        <img src="https://placehold.co/2560x1440" style="width: 100%; height: auto;" />
      </div>
    </div>
    <p-accordion [multiple]="true">
      <p-accordionTab header="Header 1">
          Content 1
      </p-accordionTab>
      <p-accordionTab header="Header 2">
          Content 2
      </p-accordionTab>
      <p-accordionTab header="Header 3">
          Content 3    
      </p-accordionTab>
  </p-accordion>
  
  </div>
</div>